import { PageViewEventLogger } from '@repo/tracking-service';
import { AuthGuard } from '@repo/user-session';
import { useAtomValue } from 'jotai';

import Layout from '@/components/layout/Layout';
import { PoaPreview } from '@/components/tax-refund/power-of-attorney/PoaPreview.tsx';
import { usePowerOfAttorneyDocumentHtml } from '@/lib/hooks/use-power-of-attorney-document-html.ts';
import { poaFormValuesAtom } from '@/lib/stores/power-of-attorney.ts';

const PowerOfAttorneyPreviewPage = () => {
  const formValues = useAtomValue(poaFormValuesAtom);
  const { documentHtml, errorMessage } = usePowerOfAttorneyDocumentHtml(formValues);

  return (
    <AuthGuard>
      <PageViewEventLogger pageName={'request_poa-preview'} eventProperty={{ status: formValues.autographDataUrl ? 'after_autograph' : 'before_autograph' }}>
        <Layout
          leftIcon={{ icon: 'back', clickEvent: { name: 'request_back' } }}
          title={<span className={'body-medium-semibold'}>위임장</span>}
          className={'bg-neutral-background-lowest h-screen'}
          mainClassName={'bg-neutral-background-lowest flex min-h-0 !max-w-full justify-center !mt-0'}
        >
          <section className="flex flex-1 min-h-0 w-full h-full pt-[1px] justify-center">
            {errorMessage ? <p className="rounded-xl bg-red-50 px-4 py-3 text-sm text-red-600">{errorMessage}</p> : <PoaPreview documentHtml={documentHtml} />}
          </section>
        </Layout>
      </PageViewEventLogger>
    </AuthGuard>
  );
};

export default PowerOfAttorneyPreviewPage;
